import React, { useEffect, useState } from 'react';
import { imageToBlob } from 'utils/ImageToBlob';

// Free fallback image (from picsum.photos)
const DEFAULT_IMAGE_URL = 'https://picsum.photos/200/300?grayscale';

export const BlobImage = ({
  dataURI,
  alt = 'Image',
  className = '',
  fallback = DEFAULT_IMAGE_URL,
}) => {
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchImage = async () => {
      setLoading(true);
      if (dataURI) {
        const localURL = await imageToBlob(dataURI);
        if (localURL) {
          setImageUrl(localURL);
        }
      }
      setLoading(false);
    };
    fetchImage();
  }, [dataURI]);

  return (
    <>
      {loading ? (
        <>
          <div className="animate-pulse bg-gray-200 rounded w-8 h-8" />
        </>
      ) : (
        <img
          src={imageUrl || fallback}
          alt={alt}
          className={`object-cover w-8 h-8 rounded-xl shadow ${className}`}
        />
      )}
    </>
  );
};
